<template>
	<div class="card md-elevation-4">
		<div style="display: flex; width: 100%">
			<div style="margin-top: auto; margin-bottom: auto">
				<md-icon class="md-size-2x">description</md-icon>
			</div>
			<div style="margin-left: auto; margin-right: 0px; margin-top: auto; margin-bottom: auto">
				<strong style="font-size: 32px">
					{{ count }}
				</strong>
			</div>
			<br />
		</div>
		<span style="float: right">{{ $t("registered-users") }}</span>
		<br />
		<span v-if="stats.this_year > 0">+</span>
		<span v-else>-</span>
		<span>{{ stats.this_year }} {{ $t("since-beginning-year") }}</span>
	</div>
</template>

<script>
import axios from "axios"
export default {
	name: "documents-chart",
	data() {
		return {
			count: 0,
			stats: {
				this_year: 0
			}
		}
	},

	created() {
		axios
			.get(process.env.VUE_APP_API_URL + "/api/user/all", {
				headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
			})
			.then(res => {
				this.count = res.data.length
				res.data.forEach(item => {
					var year = new Date(item.created_at).getFullYear()
					if (year == new Date().getFullYear()) this.stats.this_year += 1
				})
			})
			.catch(err => {
				console.error(err)
			})
	}
}
</script>

<style scoped lang="scss">
.card {
	width: 300px;
	height: 100px;
	padding: 20px;
	border-radius: 15px;
	background-color: white;
	margin: 5px;
	&:hover {
		cursor: pointer;
	}
}

.positive {
	color: green;
}
.negative {
	color: red;
}
.equal {
	color: gray;
}
span {
	font-family: "Montserrat", sans-serif;
}
</style>
